module.exports = __webpack_public_path__ + "static/media/jen.cfc04353.jpg";